/**
 * SpiceMedicalFlag: the medical or care content a SPICE email carries,
 * named above the email before anything else. The email itself is left
 * as the therapist wrote it; what reaches the family is her call.
 */

import type { ReactNode } from 'react';
import { HeartPulse } from 'lucide-react';

export function SpiceMedicalFlag({ text }: { text: string }): ReactNode {
  return (
    <div
      className="flex items-start gap-2 rounded-[12px] border border-pepper/30 border-l-[3px] border-l-pepper bg-paper p-4"
      role="note"
      data-testid="spice-medical-flag"
    >
      <HeartPulse size={16} aria-hidden="true" className="mt-0.5 shrink-0 text-pepper" />
      <div className="text-sm leading-relaxed text-ink">
        <p className="font-semibold">Medical content in this email</p>
        <p className="mt-1" data-testid="spice-medical-flag-text">
          {text}
        </p>
        <p className="mt-1 text-ink-soft">
          You may want to raise these with the care manager before this goes to the family, or
          leave them out of this update email.
        </p>
      </div>
    </div>
  );
}
